"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSidebar = void 0;
var react_1 = __importDefault(require("react"));
var menu_sidebar_styles_1 = require("./menu-sidebar.styles");
var MenuSidebar = function (_a) {
    var cabecalho = _a.cabecalho, conteudo = _a.conteudo, rodape = _a.rodape;
    return (react_1.default.createElement(menu_sidebar_styles_1.S.Nav, { "data-section": "section_menu-principal" },
        react_1.default.createElement(menu_sidebar_styles_1.S.Cabecalho, null, cabecalho),
        react_1.default.createElement(menu_sidebar_styles_1.S.Conteudo, null, conteudo),
        react_1.default.createElement(menu_sidebar_styles_1.S.Rodape, null, rodape)));
};
exports.MenuSidebar = MenuSidebar;
